import request from '@/utils/request'

/**
 * 初筛相关API接口
 */

/**
 * 获取初筛作品分类列表
 * @returns {Promise}
 */
export function getInitialScreeningCategories() {
  return request({
    url: '/reviews/pre',
    method: 'get'
  })
}

/**
 * 获取初筛作品列表
 * @param {Object} params - 查询参数
 * @param {number} params.category_id - 分类ID
 * @param {string} params.search - 搜索关键词
 * @param {string} params.is_recommend - 初筛状态筛选 (空字符串: 全部, 1: 已初筛, 0: 未初筛)
 * @param {string} params.user_id - 用户ID
 * @param {number} params.page - 页码
 * @returns {Promise}
 */
export function getInitialScreeningProducts(params) {
  return request({
    url: '/reviews/preProduct',
    method: 'get',
    params
  })
}

/**
 * 初筛推荐状态更新
 * @param {number} id - 作品ID
 * @param {number} recommend_status - 推荐状态 (0: 不推荐, 1: 推荐, 2: 未推荐)
 * @returns {Promise}
 */
export function updateInitialScreeningRecommend(id, recommend) {
  return request({
    url: `/reviews/product/pre/recommend/${id}/${recommend}`,
    method: 'put'
  })
}

/**
 * 获取初筛作品详情
 * @param {number} id - 作品ID
 * @param {string} user_id - 用户ID
 * @returns {Promise}
 */
export function getInitialScreeningProduct(id, user_id) {
  return request({
    url: `/products/${id}`,
    method: 'get'
  })
}
